const pick = function <T extends object, K extends keyof T>(target: T, ...keys: K[]): Pick<T, K> {
  const result = Object.fromEntries(
    (Object.entries(target) as [K, any][]).filter((x) => keys.includes(x[0]))
  );

  return result as Pick<T, K>;
};

export default pick;
